import { render } from "./applepay.vue?vue&type=template&id=a9de7240"
import script from "./applepay.vue?vue&type=script&lang=js"
export * from "./applepay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__